import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../core/services/api.service';
import { UserDataDto } from '../../../../dtos/user-data-dto';
import { AuthorizationEnum } from '../../../../enums/authorization-enum';
import { MessageService } from '../../../../core/services/message.service';
import { Location } from '@angular/common';
import { AddressControlComponent } from '../../../../shared/address-control/address-control.component';
import { ComboDto } from '../../../../dtos/combo-dto';

@Component({
  selector: 'users-add',
  templateUrl: './users-add.component.html',
  styleUrls: ['./users-add.component.scss']
})

export class UsersAddComponent implements OnInit {

  form: FormGroup;
  submitted: boolean;
  id: any;
  user: UserDataDto;
  isEditing: boolean;
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  authorizations: AuthorizationEnum;
  auths: string[] = ['GENERAL.ENUMS.AUTHORIZATION.ADMINISTRATOR', 'GENERAL.ENUMS.AUTHORIZATION.STORER',
    'GENERAL.ENUMS.AUTHORIZATION.DRIVER', 'GENERAL.ENUMS.AUTHORIZATION.HOST_CLIENT'];

  list: Array<ComboDto> = new Array();

  @ViewChild("addressControl") addressControl: AddressControlComponent;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.id = this.activatedRoute.snapshot.params['id'];
  }


  ngOnInit(): void {
    this.loadAuth();

    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      firstLastName: ['', Validators.required],
      secondLastName: [''],
      username: ['', Validators.required],
      password: ['', Validators.required],
      authorization: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.minLength(6)]],
      email: ['', [Validators.required, Validators.email]],
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';

      this.apiService.get('api/user/dto/' + this.id).subscribe((data: any) => {
        this.user = data.data;
        this.form = this.formBuilder.group({
          name: [this.user.name, Validators.required],
          firstLastName: [this.user.firstLastName, Validators.required],
          secondLastName: [this.user.secondLastName],
          username: [this.user.username, Validators.required],
          password: [this.user.password, Validators.required],
          authorization: [this.user.authorization, Validators.required],
          telephone: [this.user.telephone, [Validators.required, Validators.minLength(6)]],
          email: [this.user.email, [Validators.required, Validators.email]],
        });
        this.addressControl.setAddressData(this.user);
        this.addressControl.setLatLong(this.user.lat, this.user.long);
      });

    }
  }

  get controls() { return this.form.controls; }

  back() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    let addressControlData = this.addressControl.getAddressData();
    if (this.form.invalid || addressControlData.isInvalid) {
      return;
    }
    let client: UserDataDto = this.form.value as UserDataDto;
    let address: UserDataDto = addressControlData.values as UserDataDto;

    let model = Object.assign({}, client, address);

    if (!model.intNumber)
      model.intNumber = 0;

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/user/updateFromDto', model).subscribe((response: any) => {
        this.messageService.success("USERS.MESSAGES.SUCCESS", "USERS.MESSAGES.USERNAME_UPDATED");
        this.location.back();
      });
    }
    else {
      this.apiService.post('api/user/saveFromDto', model).subscribe((response: any) => {
        this.messageService.success("USERS.MESSAGES.SUCCESS", "USERS.MESSAGES.USERNAME_SAVED");
        this.location.back();
      });
    }
  }

  private loadAuth(): void {
    for (let a in AuthorizationEnum) {
      if (typeof AuthorizationEnum[a] == 'string') {
        this.list.push(new ComboDto(+a, 'GENERAL.ENUMS.AUTHORIZATION.' + AuthorizationEnum[a]));
      }
    }
  }
}
